import EvalComDeporte from "pages/LandingPages/EvalComDeporte/evalComDeporte";

export default function EvalComDeportePage() {
  return <EvalComDeporte />;
}
